module.exports = __webpack_public_path__ + "static/media/slumberland.777565e2.png";